/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getStats: async (params) => exeRequest(`/admin/dashboard/stats${buildQuery(params)}`, "GET"),

    getKpis: async (params) => exeRequest(`/admin/dashboard/kpis${buildQuery(params)}`, "GET"),

    getEcheances: async (params) => exeRequest(`/admin/dashboard/echeances${buildQuery(params)}`, "GET"),

    getDerniersContrats: async (params) => exeRequest(`/admin/dashboard/derniers-contrats${buildQuery(params)}`, "GET"),

    getCaEvolution: async (params) => exeRequest(`/admin/dashboard/ca-evolution${buildQuery(params)}`, "GET"),

    getRepartitionTypes: async (params) => exeRequest(`/admin/dashboard/repartition-types${buildQuery(params)}`, "GET"),

    getSinistresEnCours: async (params) => exeRequest(`/admin/dashboard/sinistres-en-cours${buildQuery(params)}`, "GET"),

    getTopClients: async (params) => exeRequest(`/admin/dashboard/top-clients${buildQuery(params)}`, "GET"),

    getDerniersClients: async (params) => exeRequest(`/admin/dashboard/derniers-clients${buildQuery(params)}`, "GET"),

    getAlertes: async (params) => exeRequest(`/admin/dashboard/alertes${buildQuery(params)}`, "GET"),
};
